import { render } from "./QuestionSixteen.vue?vue&type=template&id=16c2ff8e"
import script from "./QuestionSixteen.vue?vue&type=script&lang=js"
export * from "./QuestionSixteen.vue?vue&type=script&lang=js"

import "./QuestionSixteen.vue?vue&type=style&index=0&id=16c2ff8e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__